import { render, staticRenderFns } from "./phoneCatalogue.vue?vue&type=template&id=96763c40&scoped=true"
import script from "./phoneCatalogue.vue?vue&type=script&lang=js"
export * from "./phoneCatalogue.vue?vue&type=script&lang=js"
import style0 from "./phoneCatalogue.vue?vue&type=style&index=0&id=96763c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96763c40",
  null
  
)

export default component.exports